import React, { createContext, useContext, FunctionComponent } from 'react';
import styled from 'styled-components';

export interface ExperimentProps {
  id: string;
}
const ExperimentContext = createContext('experiment');

export const Experiment: FunctionComponent<ExperimentProps> = ({
  id,
  children,
}) => (
  <ExperimentContext.Provider value={id}>{children}</ExperimentContext.Provider>
);

const Container = styled.div``;

export interface VariantProps {
  name: string;
}

export const Variant: FunctionComponent<VariantProps> = ({
  name,
  children,
}) => {
  const expName = useContext(ExperimentContext);
  return (
    <Container
      style={{ display: 'none' }}
      data-testid={`${expName}-${name}`}
      className={`${expName}-${name}`}
    >
      {children}
    </Container>
  );
};

export const Control: FunctionComponent = ({ children }) => {
  const expName = useContext(ExperimentContext);
  return (
    <Container
      data-testid={`${expName}-control`}
      className={`${expName}-control`}
    >
      {children}
    </Container>
  );
};
